import { render, staticRenderFns } from "./ot-organisation-details-index.vue?vue&type=template&id=bae72660&scoped=true&"
import script from "./ot-organisation-details-index.vue?vue&type=script&lang=ts&"
export * from "./ot-organisation-details-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-organisation-details-index.vue?vue&type=style&index=0&id=bae72660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae72660",
  null
  
)

export default component.exports